var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M12 1C5.95 1 1 5.94 1 12c0 3 1.21 5.72 3.16 7.7l.04.05A11.02 11.02 0 0 0 23 12c0-6.06-4.93-11-11-11m0 1.1c5.46 0 9.91 4.44 9.91 9.9 0 2.43-.9 4.66-2.35 6.4a8.55 8.55 0 0 0-5.47-4.27 4.1 4.1 0 1 0-6.19-3.5c0 1.5.81 2.79 2.01 3.5a8.52 8.52 0 0 0-5.47 4.26A9.86 9.86 0 0 1 2.1 12c0-5.46 4.45-9.9 9.9-9.9h.02Zm-3 8.53a3 3 0 1 1 6.02 0 3 3 0 0 1-6.02 0m-3.74 8.6a7.47 7.47 0 0 1 13.5 0 9.87 9.87 0 0 1-13.5 0"
})));
export { SvgMenuAccount as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzY2MmJkZDdlNzRmMjZkMWVhZDRhZjYwZTk1YjU3MWEuc3ZnIjs=";